import { Box, Flex,Text } from '@chakra-ui/react'
import React from 'react'
import {motion} from 'framer-motion'
export const Pricing = () => {
  return (
    
    <Flex name='Pricing' justifyContent={'center'} margin={'3rem auto'} gap={'5'} flexDirection={{xs:'column',sm:'column',ls:'column',md:'column',lg:'row',xl:'row','2xl':'row'}}>
        <Box 
        width={'15rem'} 
        padding={'1rem'} 
        border={'1px solid rgba(0, 0, 0, 0.15)'} 
        textAlign={'center'} 
        display={'flex'} 
        flexDirection={'column'} 
        bgGradient={' linear-gradient(180deg, rgba(212, 217, 255, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);'} 
        boxShadow={'0px 4px 4px rgba(0, 0, 0, 0.15)'}>
        <Text fontWeight={'900'} fontSize={'1.3rem'}>PLAN BÁSICO</Text>
        <Box margin={'auto'}>
        <Text margin={'0.5rem'}>
        8 Posteos mensuales
        </Text>
        <Text  margin={'0.5rem'}>
        3 Historias Semanales
            </Text>
        <Text  margin={'0.5rem'}>
        1 Reel Mensual
        </Text>
        </Box>   
        <Text 
        fontWeight={'900'} 
        fontSize={'1.3rem'} 
        margin={'1rem 0rem'}>
            $7.000
        </Text>     
       </Box>
       <Box 
       width={'15rem'} 
       padding={'1rem'} 
       border={'1px solid rgba(0, 0, 0, 0.15)'} 
       textAlign={'center'} 
       display={'flex'} 
       flexDirection={'column'} 
       bgGradient={' linear-gradient(180deg, rgba(212, 217, 255, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);'} 
       boxShadow={'0px 4px 4px rgba(0, 0, 0, 0.15)'}>
        <Text fontWeight={'900'} fontSize={'1.3rem'}>PLAN ESTÁNDAR</Text>   
        <Box margin={'auto'}>
        <Text margin='0.5rem'>
        12 Posteos mensuales
        </Text>
        <Text margin='0.5rem'>
        5 Historias Semanales
        </Text>
        <Text margin='0.5rem'>
        2 Reel Mensual
        </Text>
        <Text margin='0.5rem'>
        Seguimiento de métricas
        </Text>
        </Box>
        <Text 
        fontWeight={'900'} 
        fontSize={'1.3rem'}
        margin='1rem 0rem'>
            $10.000
        </Text>
       </Box>
       <Box width={'15rem'} 
       padding={'1rem'}  
       border={'1px solid rgba(0, 0, 0, 0.15)'} textAlign={'center'} 
       display={'flex'} 
       flexDirection={'column'} 
       bgGradient={' linear-gradient(180deg, rgba(212, 217, 255, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);'} 
       boxShadow={'0px 4px 4px rgba(0, 0, 0, 0.15)'}>
        <Text fontWeight={'900'} fontSize={'1.3rem'}>PLAN PREMIUM</Text>
    <Box margin={'auto'}>
        <Text margin='0.5rem'>
        12 Posteos mensuales
    </Text>   
    <Text margin='0.5rem'>
        5 Historias Semanales
    </Text>
    <Text margin='0.5rem'>
        2 Reel Mensual
    </Text>
    <Text margin='0.5rem'>
        Seguimiento de métricas
    </Text>
    <Text margin='0.5rem'>
        Responder Mensajes
    </Text>
    <Text margin='0.5rem'>
        Mediar Comentarios
    </Text>
    </Box>
    <Text 
    fontWeight={'900'} 
    fontSize={'1.3rem'} 
    margin='1rem 0rem'> 
        $16.000
    </Text>
       </Box>                
    </Flex>

  )
}
